module.exports = __webpack_public_path__ + "img/wellnessbiscuit.abfed74f.jpg";